import { Identity, IdVerification, PersonaIdVerification } from "./interfaces";

const VERIFIED_STATUSES = new Set([
  "completed",
  "passed",
  "approved",
  "verified",
]);
const UNVERIFIED_STATUSES = new Set([
  "failed",
  "declined",
  "expired",
  "rejected",
  "unverified",
]);

const getAttr = (
  attributes?: Record<string, any>,
  camelCaseKey?: string,
  dashedKey?: string
) => {
  if (!attributes) return undefined;
  if (camelCaseKey && attributes[camelCaseKey] !== undefined) {
    return attributes[camelCaseKey];
  }
  if (dashedKey && attributes[dashedKey] !== undefined) {
    return attributes[dashedKey];
  }
  return undefined;
};

export const mapIdentities = (
  verifications?: IdVerification[],
  enabled?: boolean,
  idVerifications?: PersonaIdVerification[]
): Identity | undefined => {
  if (!verifications && !idVerifications) return undefined;
  const verification = verifications?.find(
    (item) =>
      item?.verificationType === "ID" ||
      item?.verification_type === "ID" ||
      item?.type === "ID"
  );
  const details = verification?.details;
  const personaVerification =
    idVerifications?.find((item) => item?.type === "verification/government-id") ||
    idVerifications?.find((item) => item?.attributes);
  const attributes = personaVerification?.attributes;
  const detailsStatus = details?.status;
  const verificationStatus = verification?.status;
  const personaStatus = getAttr(attributes, "status");
  const status = (detailsStatus || verificationStatus || personaStatus || "").toLowerCase();

  let verified: boolean | undefined;
  if (VERIFIED_STATUSES.has(status)) {
    verified = true;
  } else if (UNVERIFIED_STATUSES.has(status)) {
    verified = false;
  }

  const expirationDate =
    details?.expirationDate ||
    getAttr(attributes, "expirationDate", "expiration-date");

  return {
    documentType:
      details?.documentClass || getAttr(attributes, "idClass", "id-class"),
    enabled,
    verified,
    identityNumber:
      details?.identificationNumber ||
      getAttr(attributes, "identificationNumber", "identification-number"),
    country:
      details?.addressCountryCode || getAttr(attributes, "countryCode", "country-code"),
    expires: expirationDate ? new Date(expirationDate) : undefined,
  };
};
